<template>
  <div class="weScan">
    <!-- 微信二维码弹框 -->
    <el-dialog
      :show-close="false"
      :visible.sync="loginVisibleCom"
      custom-class="loginDialogWe"
    >
      <div class="weBox">
        <div class="logoBox">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="240px"
            height="240px"
            viewBox="0 0 240 240"
            version="1.1"
          >
            <title>logo图形</title>
            <g
              id="logo图形"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g id="编组-24" transform="translate(27.000000, 56.000000)">
                <path
                  d="M15.7285156,127.703125 C18.2871094,127.703125 21.0410156,127.380859 23.9902344,126.736328 L23.9902344,126.736328 L23.1113281,118.503906 C21.5292969,119.011719 20.2988281,119.265625 19.4199219,119.265625 C18.4433594,119.265625 17.7597656,118.933594 17.3691406,118.269531 C17.1152344,117.839844 16.9882812,116.960938 16.9882812,115.632812 L16.9882812,115.632812 L16.9882812,104.587891 L23.5507812,104.587891 L23.5507812,95.8867188 L16.9882812,95.8867188 L16.9882812,84.0507812 L5.03515625,90.1738281 L5.03515625,95.8867188 L0.640625,95.8867188 L0.640625,104.587891 L5.03515625,104.587891 L5.03515625,115.544922 C5.03515625,119.021484 5.37207031,121.536133 6.04589844,123.088867 C6.71972656,124.641602 7.75976562,125.798828 9.16601562,126.560547 C10.5722656,127.322266 12.7597656,127.703125 15.7285156,127.703125 Z M39.6347656,127.703125 C42.0957031,127.703125 44.1708984,127.263672 45.8603516,126.384766 C47.5498047,125.505859 49.2246094,124.03125 50.8847656,121.960938 L50.8847656,121.960938 L50.8847656,127 L62.0175781,127 L62.0175781,95.8867188 L50.09375,95.8867188 L50.09375,110.857422 C50.09375,113.689453 49.6396484,115.652344 48.7314453,116.746094 C47.8232422,117.839844 46.65625,118.386719 45.2304688,118.386719 C43.921875,118.386719 42.90625,117.976562 42.1835938,117.15625 C41.4609375,116.335938 41.0996094,114.949219 41.0996094,112.996094 L41.0996094,112.996094 L41.0996094,95.8867188 L29.1171875,95.8867188 L29.1171875,115.691406 C29.1171875,119.773438 30.0498047,122.795898 31.9150391,124.758789 C33.7802734,126.72168 36.3535156,127.703125 39.6347656,127.703125 Z M79.6542969,127.703125 C82.1152344,127.703125 84.1904297,127.263672 85.8798828,126.384766 C87.5693359,125.505859 89.2441406,124.03125 90.9042969,121.960938 L90.9042969,121.960938 L90.9042969,127 L102.037109,127 L102.037109,95.8867188 L90.1132812,95.8867188 L90.1132812,110.857422 C90.1132812,113.689453 89.6591797,115.652344 88.7509766,116.746094 C87.8427734,117.839844 86.6757812,118.386719 85.25,118.386719 C83.9414062,118.386719 82.9257812,117.976562 82.203125,117.15625 C81.4804688,116.335938 81.1191406,114.949219 81.1191406,112.996094 L81.1191406,112.996094 L81.1191406,95.8867188 L69.1367188,95.8867188 L69.1367188,115.691406 C69.1367188,119.773438 70.0693359,122.795898 71.9345703,124.758789 C73.7998047,126.72168 76.3730469,127.703125 79.6542969,127.703125 Z M119.673828,127.703125 C122.134766,127.703125 124.209961,127.263672 125.899414,126.384766 C127.588867,125.505859 129.263672,124.03125 130.923828,121.960938 L130.923828,121.960938 L130.923828,127 L142.056641,127 L142.056641,95.8867188 L130.132812,95.8867188 L130.132812,110.857422 C130.132812,113.689453 129.678711,115.652344 128.770508,116.746094 C127.862305,117.839844 126.695312,118.386719 125.269531,118.386719 C123.960938,118.386719 122.945312,117.976562 122.222656,117.15625 C121.5,116.335938 121.138672,114.949219 121.138672,112.996094 L121.138672,112.996094 L121.138672,95.8867188 L109.15625,95.8867188 L109.15625,115.691406 C109.15625,119.773438 110.088867,122.795898 111.954102,124.758789 C113.819336,126.72168 116.392578,127.703125 119.673828,127.703125 Z M158.931641,127 L165.699219,116.980469 L171.441406,127 L185.357422,127 L173.990234,110.710938 L184.595703,95.8867188 L171.441406,95.8867188 L165.699219,104.558594 L160.748047,95.8867188 L146.597656,95.8867188 L157.320312,110.710938 L146.011719,127 L158.931641,127 Z"
                  id="tuuux"
                  fill="#306EF2"
                  fill-rule="nonzero"
                />
                <path
                  d="M6.6,56.5017173 C5.66308594,20.6148532 39.6052734,14.2752736 43.7396484,13.0512501 C47.8740234,11.8272267 51.6304688,9.13165009 51.6304688,9.13165009 C51.6304688,9.13165009 65.2066406,-2.30350616 75.6,0.419023582 C85.9933594,3.14155333 92.3784186,9.6062922 96.0896484,15.4076266 C99.8008783,21.2089611 108.492471,31.0241867 93.9390099,62.0163276 C91.0569644,68.1537514 85.9423889,75.8836828 82.3500977,78.1825656 C72.9065069,84.2259808 63.5643445,83.0861868 54.3236105,74.7631836"
                  id="路径-2备份"
                  stroke="#306EF2"
                  stroke-width="12"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <circle
                  id="椭圆形"
                  fill="#306EF2"
                  cx="37.5"
                  cy="52.5"
                  r="6.5"
                />
                <path
                  d="M102,28.3962524 C120.390519,26.5233698 133.821458,26.5233698 142.292816,28.3962524 C154.999853,31.2055763 180,42.0325656 180,78.1825656"
                  id="路径-3备份"
                  stroke="#306EF2"
                  stroke-width="12"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
            </g>
          </svg>
        </div>
        <div class="qrCodeBox" id="qrCode">
          <img :src="qrCodeUrl" alt="" v-if="qrCodeUrl" />
        </div>
        <div class="textTip">
          <p>请使用微信扫描二维码</p>
          <p>关注公众号登录</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import api from "@/utils/request.js";
export default {
  name: "Main",
  props: {
    loginVisible: {
      type: Boolean,
    },
    registeredSuccessVisible: {
      type: Boolean,
    },
    registeredVisible: {
      type: Boolean,
    },
  },
  data() {
    return {
      loginVisibleCom: false,
      qrCodeUrl: "",
      ticket: "",
      timer: "",
      TimeSpanStr: "",
      sceneId: "",
    };
  },
  // mounted() {
  //   this.loginVisibleCom = this.loginVisible;
  // },
  watch: {
    loginVisible(val) {
      this.loginVisibleCom = val;
    },
    loginVisibleCom(val) {
      if (!val) {
        let than = this;
        window.clearInterval(than.timer);
      } else {
        this.getQRCode();
      }
      this.emitFunction();
    },
  },
  methods: {
    getFocusState() {
      let that = this;
      axios({
        headers: {
          "Login-Token": that.sceneId,
        },
        method: "get",
        url: "/api/auth/user/info",
      })
        .then((response) => {
          let res = response.data;
          if (res.code == 200) {
            window.clearInterval(that.timer);
            this.$storage.set("id", res.data.id);
            this.$storage.set("token", that.sceneId);
            this.loginVisibleCom = false;
            // 告诉Main
            this.$emit("callFather");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getQRCode() {
      let that = this;
      api({
        method: "get",
        url: "/api/auth/qrcode",
      }).then((response) => {
        console.log("获取登录二维码接口成功");
        that.sceneId = response.data.sceneId;
        sessionStorage.setItem('sceneId',response.data.sceneId)
        const urlEncodeTicket = encodeURIComponent(response.data.ticket);
        that.qrCodeUrl = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${urlEncodeTicket}`;
        this.timer = setInterval(function () {
          that.getFocusState();
        }, 1000);
      });
    },
    emitFunction() {
      var dialogData = {
        loginVisible: this.loginVisibleCom,
      };
      this.$emit("dialog-change", dialogData);
    },
  },
};
</script>
<style>
.qrCodeBox img {
  display: inline-block !important;
}
@media screen and (max-width: 1600px) {
  .loginDialogWe {
    /* width: 6.28rem !important; */
    margin-top: 0 !important;
    background: #fff;
    width: 333px !important;
    height: 405px !important;
    transform: translateY(-50%);
    top: 50%;
    border-radius: 8px;
  }

  /* 登录弹框 */
  .loginDialogWe .el-dialog__body {
    padding: 0px;
  }
  .loginDialogWe .el-dialog__header {
    padding: 0px;
    height: 0px;
  }
}
@media (min-width: 1600px) {
  .loginDialogWe {
    background: #fff;
    margin-top: 0 !important;
    width: 400px !important;
    height: 486px !important;
    transform: translateY(-50%);
    top: 50%;
    border-radius: 9px;
  }

  /* 登录弹框 */
  .loginDialogWe .el-dialog__body {
    padding: 0px;
  }
  .loginDialogWe .el-dialog__header {
    padding: 0px;
    height: 0px;
  }
}
</style>
<style scoped lang="less">
@media (min-width: 1600px) {
  .loginDialogWe {
    .weBox {
      .logoBox {
        margin-top: 48px;
        text-align: center;
        svg {
          width: 81px;
          height: 81px;
        }
      }
      .qrCodeBox {
        text-align: center;
        img {
          width: 215px;
          height: 215px;
          display: inline-block !important;
        }
      }
      .textTip {
        margin-top: 19px;
        p {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #838591;
          line-height: 26px;
          text-align: center;
        }

        p:nth-of-type(2) {
          font-weight: bold;
          color: #000;
        }
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .loginDialogWe {
    .weBox {
      .logoBox {
        text-align: center;
        margin-top: 40px;
        svg {
          width: 68px;
          height: 68px;
        }
      }
      .qrCodeBox {
        text-align: center;
        img {
          width: 172px;
          height: 172px;
        }
      }
      .textTip {
        margin-top: 16px;

        p {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #838591;
          line-height: 22px;
          text-align: center;
        }

        p:nth-of-type(2) {
          font-weight: bold;
          color: #000;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommponentDialogWe.vue